import { useQuery } from '@tanstack/react-query'
import { httpGetMMCounts } from '@/features/luxe-submissions/http/luxe-submissions.http'

export const MM_COUNTS_QUERY_KEY = 'mm-counts'

export const useGetMMCounts = () =>
	useQuery({
		queryKey: [MM_COUNTS_QUERY_KEY],
		queryFn: () => httpGetMMCounts()
	})
